<template>
	<div class="m_container" :class="openType != 'mob' ? 'flex_center flex_items vh100 oy' : ''">
		<div class="page_bg" style="box-sizing: border-box;"
			:class="openType != 'mob' ? 'container_w_h' : 'vh100'">
			<div class="bgfff mb20 plr20 mb20">
				<div class="pt20 pb20 bor_b" v-for="(item,index) in list" :key="index">
					<div class="flex_items flex_between mb10">
						<div class="">{{item.title}}</div>
						<div :class="item.amount > 0 ? 'main_color' : 'red'">{{item.amount}}</div>
					</div>
					<div class="flex_items flex_between ca6">
						<div class="">{{item.created_at}}</div>
						<div class="">剩余：{{item.balance}}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		openType
	} from '@/utils/tool.js'
	export default ({
		data() {
			return {
				id: 1,
				openType: openType(),
				list:[],
			}
		},
		created() {
			this.openType = openType()
			this.id = this.$route.query.id;
			this.getList()
		},
		methods: {
			getList() {
				this.api.scoreLogs({user_id:this.id}).then(res => {
					this.list = res.data
				})
			},
		}
	})
</script>
<style scoped="scoped">
	.bg_blue{
		background-color: #C2E1FF;
		color: #3399FF;
	}
	.y_bg{
		background-color: #FFF0D1;
		color: #FF9966;
	}
	.gr_bg{
		color: #00D8CC;
		background-color: #D1F0E1;
	}
	.container_w_h{
		height: 700px;
		overflow-y: auto;
	}
</style>